export const MAX_OFFER_IMAGE_UPLOAD_COUNT = 5;
export const MAX_OFFER_IMAGE_SIZE_BYTES = 2 * 1024 * 1024;

type OfferImageUploadValidationResult =
  | { isValid: true }
  | { isValid: false; error: string };

export const validateOfferImageSelection = (
  existingFiles: File[],
  selectedFiles: File[]
): OfferImageUploadValidationResult => {
  if (existingFiles.length + selectedFiles.length > MAX_OFFER_IMAGE_UPLOAD_COUNT) {
    return {
      isValid: false,
      error: `Możesz wybrać maksymalnie ${MAX_OFFER_IMAGE_UPLOAD_COUNT} zdjęć.`,
    };
  }

  const oversizedFile = selectedFiles.find((file) => file.size > MAX_OFFER_IMAGE_SIZE_BYTES);

  if (oversizedFile) {
    return {
      isValid: false,
      error: `Plik "${oversizedFile.name}" przekracza maksymalny rozmiar 2 MB.`,
    };
  }

  return { isValid: true };
};
